// Firestore-backed System Config
import { getFirestore, doc, getDoc, setDoc, onSnapshot } from "firebase/firestore";
import { app as firebaseApp, serverTimestamp } from "@/firebase";

const db = getFirestore(firebaseApp);
const DOC_PATH = "sysconfig/main"; // single doc to hold system config

const DEFAULTS = {
  uploads: {
    maxPdfMB: 25, // sane default if doc doesn’t exist yet
  },
  restrictions: {
    adminOnlyArchive: false,
  },
  entrata: {
    showPmWorkOrderMapping: false,
  },
};

export async function getSysConfigFS() {
  const snap = await getDoc(doc(db, DOC_PATH));
  if (!snap.exists()) return { ...DEFAULTS };
  // merge with defaults to avoid undefined branches
  return deepMerge({ ...DEFAULTS }, snap.data() || {});
}

export async function saveSysConfigFS(nextCfg, actor = null) {
  const ref = doc(db, DOC_PATH);
  const now = serverTimestamp();
  const payload = {
    ...nextCfg,
    _meta: {
      updatedAt: now,
      updatedBy: actor?.email || actor?.displayName || "system",
    },
  };
  await setDoc(ref, payload, { merge: true });
  return payload;
}

export function subscribeSysConfigFS(callback) {
  const ref = doc(db, DOC_PATH);
  return onSnapshot(ref, (snap) => {
    if (snap.exists()) {
      const data = deepMerge({ ...DEFAULTS }, snap.data() || {});
      callback(data);
    } else {
      callback({ ...DEFAULTS });
    }
  });
}

// ---- helpers ----
function isObject(x) { return x && typeof x === "object" && !Array.isArray(x); }
function deepMerge(target, source) {
  const out = { ...target };
  for (const [k, v] of Object.entries(source || {})) {
    if (isObject(v) && isObject(out[k])) out[k] = deepMerge(out[k], v);
    else out[k] = v;
  }
  return out;
}
